import { StructureCollection } from "./StructureCollection";

export class LightStructureCollection extends StructureCollection {

    constructor(date: Date) {
        super(date);
        this.Type = "LightStructureCampaign";
    }
}
